export const fetchingProduct = async (
  endPoint,
  type = "POST",
  lineOrId = "id",
  variantId,
  quantity = 1
) => {
  const options = {
    method: type,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  if (type === "POST") {
    const key = lineOrId === "line" ? "line" : "id";
    options.body = JSON.stringify({
      [key]: variantId.toString(),
      quantity: quantity,
    });
  }

  return fetch(endPoint, options)
    .then((res) => {
      if (!res.ok) {
        return res.json().then((error) => {
          throw new Error(error.description || "Error processing request");
        });
      }
      return res.json();
    })
    .catch((error) => {
      throw new Error(error.message || "Network error");
    });
};
